import type { AlgoliaStoreConfig } from '@algolia-search/types';

export const INDEX_PRODUCTS = 'products';
export const INDEX_CATEGORIES = 'categories';
export const INDEX_SUGGESTIONS = 'suggestions';
export const INDEX_CONTENTFUL_PAGES = 'contentful_pages';

export const PRODUCT_TYPE_MAP = {
  simple: 'SimpleProduct',
  bundle: 'BundleProduct',
  virtual: 'VirtualProduct'
};

export const CONFIG_KEYS = {
  autocompleteDebounce: 'algoliasearch_autocomplete_autocomplete_debounce_millisec',
  autocompleteMinimumChars: 'algoliasearch_autocomplete_autocomplete_minimum_char_length',
  productsSuggestionsCount: 'algoliasearch_autocomplete_autocomplete_nb_of_products_suggestions',
  categoriesSuggestionsCount: 'algoliasearch_autocomplete_autocomplete_nb_of_categories_suggestions',
  queriesSuggestionsCount: 'algoliasearch_autocomplete_autocomplete_nb_of_queries_suggestions',
  sorts: 'algoliasearch_instant_instant_sorts_sorts',
  facets: 'algoliasearch_instant_instant_facets_facets',
  maxValuesPerFacet: 'algoliasearch_instant_instant_facets_max_values_per_facet',
  recentSearchesCount: 'algoliasearch_autocomplete_autocomplete_nb_of_recent_searches'
} as const;

const DEFAULT_SUGGESTIONS_COUNT = '4';
const DEFAULT_FACETS_COUNT = '10';

export const DEFAULT_ALGOLIA_CONFIG: AlgoliaStoreConfig = {
  algoliasearch_autocomplete_autocomplete_debounce_millisec: '300',
  algoliasearch_autocomplete_autocomplete_minimum_char_length: '3',
  algoliasearch_autocomplete_autocomplete_nb_of_products_suggestions: DEFAULT_SUGGESTIONS_COUNT,
  algoliasearch_autocomplete_autocomplete_nb_of_categories_suggestions: DEFAULT_SUGGESTIONS_COUNT,
  algoliasearch_autocomplete_autocomplete_nb_of_queries_suggestions: DEFAULT_SUGGESTIONS_COUNT,
  algoliasearch_autocomplete_autocomplete_nb_of_recent_searches: '1',
  algoliasearch_instant_instant_sorts_sorts: '{}',
  algoliasearch_instant_instant_facets_facets: '{}',
  algoliasearch_instant_instant_facets_max_values_per_facet: DEFAULT_FACETS_COUNT
} as const;

export const SEPARATORS = {
  keyValue: '=',
  filter: ',',
  multiValue: '|',
  index: '_'
};
